import { Injectable } from '@angular/core';
import {jsPDF} from 'jspdf';
import autoTable  from 'jspdf-autotable';

const PDF_EXTENSION = '.pdf';

@Injectable()
export class PdfService {
    constructor() { }
    public exportAsPdfFile(json: any[], pdfFileName: string): void {
        var doc = new jsPDF();
        for (let i = 0; i < json.length; i++) {
            const header = [];
            const bodyMain = [];
            for (let j = 0; j < json[i].length; j++) {
                let body = [];
                for (let key in json[i][j]) {
                    if (!header.includes(key)) { header.push(key); }
                    body.push(json[i][j][key]);
                }
                bodyMain.push(body);
            }
             autoTable(doc,{
                head: [header],
                 body: bodyMain,
             })
        }
        this.saveAsPdfFile(doc, pdfFileName);
    }
    private saveAsPdfFile(buffer: any, fileName: string): void {
        buffer.save(fileName + '_export' + PDF_EXTENSION);
    }
}
